// extracted by mini-css-extract-plugin
export default {"f":"_2a7dd8bf71","main":"_44dfab0093","btn":"_89fc8fa11e","w":"_63ee67f3bf","h":"_4408e022d6","lh25":"_1ee96ac333","wb":"d7026e6ca0","b":"c4f74fd5cb","bx":"_356a3159cf"};